import React, { FunctionComponent } from 'react';
import { formatMoney } from 'accounting';
import { FieldToAdjust } from '@upstart/harmony/lib/legos/paymentRollbackTypes';
import { PaymentRollbackModalSummaryProps } from './types';

export const PaymentRollbackOfferSummary: FunctionComponent<PaymentRollbackModalSummaryProps> = props => {
  const { label, message, fieldToAdjust } = props;

  const { monthlyPayment, price, trade, downPayment, apr } =
    props.offerSummary || {};

  return (
    <>
      <label>{label}</label>
      {props.offerSummary ? (
        <table>
          <tbody>
            <tr>
              <td>Monthly Payment</td>
              <td className="payment-rollback-display-in-blue">
                {monthlyPayment ? formatMoney(monthlyPayment) : formatMoney(0)}
              </td>
            </tr>
            <tr>
              <td>Selling Price</td>
              <td
                className={
                  fieldToAdjust === FieldToAdjust.SELLING_PRICING
                    ? 'payment-rollback-display-in-blue'
                    : ''
                }
              >
                {price ? formatMoney(price) : formatMoney(0)}
              </td>
            </tr>
            <tr>
              <td>Trade</td>
              <td>{trade ? formatMoney(trade) : formatMoney(0)}</td>
            </tr>
            <tr>
              <td>Down Payment</td>
              <td
                className={
                  fieldToAdjust === FieldToAdjust.DOWNPAYMENT
                    ? 'payment-rollback-display-in-blue'
                    : ''
                }
              >
                {downPayment ? formatMoney(downPayment) : formatMoney(0)}
              </td>
            </tr>
            <tr>
              <td>Interest Rate (APR)</td>
              <td>{apr && `${+(apr * 100).toFixed(2)}%`}</td>
            </tr>
          </tbody>
        </table>
      ) : (
        <div> {message} </div>
      )}
    </>
  );
};
